<template>
  <div class="wxapp-customMessagepage">
    <SpFinder ref="finder" :url="page_list" noSelection :setting="pageSetting" fixed-row-action :split-count="10"
      :hooks="{ beforeSearch }" rowActionsWidth="130px" rowActionsAlign="left">
    </SpFinder>
    <router-view></router-view>
  </div>
</template>

<script>
import { pageSetting } from './config/index'
import { getTaskDetail } from '@/api/point'
import { useDialog } from '@shopex/finder'

const page_list = '/member/points/task/list'

export default {
  components: {},
  computed: {
    pageSetting() {
      return pageSetting(this)
    }
  },
  data() {
    return {
      page_list

    }
  },
  async mounted() {
  },
  methods: {
    async handleAddTask(id) {
      let info = {}
      if (id) {
        const { data } = await getTaskDetail({ id })
        info = data.data
      }
      useDialog(null, {
        title: id ? '编辑任务' : '添加任务',
        info,
        component: () => import('./components/edit.vue'),
        actions: [
          { label: '确定', key: 'save', type: 'primary', size: 'default' },
          { label: '取消', key: 'close', size: 'default' }
        ]
      }).then(arg => {
        if (arg) this.refresh()
      })
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    handleClickTab() {
      this.refresh()
    },
    beforeSearch(params) {
      return {
        ...params,
        page_size: params.pageSize
      }
    }
  },
}
</script>

<style scoped lang="scss"></style>
